module.exports = __webpack_public_path__ + "static/template-preview-838f4754e69cee0006b0025467aff634.png";